import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ICONS } from "@/components/icons";

interface TwitterLinkNoticeProps {
  onConnect: (redirectUrl: string) => void;
}

export const TwitterLinkNotice = ({ onConnect }: TwitterLinkNoticeProps) => (
  <div className="w-full relative bg-gradient-to-br from-swapper-primary/5 to-[#9F7FFF]/5 border-2 border-swapper-primary/20 rounded-2xl p-6 md:p-8 shadow-lg">
    <div className="flex flex-col items-center gap-4 md:gap-6">
      {/* Icon */}
      <div className="relative bg-gradient-to-br from-swapper-primary to-[#9F7FFF] p-5 rounded-2xl shadow-md">
        <img
          src={ICONS.x}
          alt="X (Twitter)"
          width={32}
          height={32}
          className="md:w-10 md:h-10"
          style={{ filter: "invert(1)" }}
        />
      </div>

      {/* Text content */}
      <div className="text-center space-y-2 md:space-y-3">
        <h3 className="text-lg md:text-xl font-bold text-swapper-secondary">
          Connect your X account
        </h3>
        <p className="text-sm md:text-base text-swapper-secondary/70 leading-relaxed max-w-md px-2">
          Connect your X (Twitter) account to complete social tasks and verify your actions on the platform.
        </p>
      </div>

      <Button
        onClick={() => onConnect(window.location.href)}
        className="w-full max-w-sm bg-gradient-to-br from-swapper-primary to-[#9F7FFF] hover:opacity-90 text-white font-semibold rounded-xl px-6 py-3 transition-all duration-200 ease-out hover:shadow-glow text-sm md:text-base"
      >
        <span className="inline-flex items-center justify-center gap-2">
          <img
            src={ICONS.x}
            alt=""
            width={18}
            height={18}
            style={{ filter: "invert(1)" }}
          />
          <span>Connect with X</span>
        </span>
      </Button>
    </div>
  </div>
);
